OverallTracking = new (function () {
  const { callApi } = Shared;
  const { COLORS } = CONSTANTS;

  const DEFAULT_PADDING = 91,
    TD_PADDING = 12,
    TARGET_LEFT_MARGIN = 10,
    TARGET_RIGHT_MARGIN = 5,
    TARGET_CIRCLE_PADDING = 3,
    MAX = 100;

  let wrapper, yearGroupInput, targetInput;

  function setTarget(e) {
    const value = e.target && e.target.value;
    if (isNaN(value)) return;

    const yearGroup = yearGroupInput.val();
    const data = { tracking_target: { year_group: yearGroup, value: value } };
    const options = { isAlertsOn: { fail: true, success: true } };
    return callApi({
      url: `/tracking_targets/upsert`,
      method: "post",
      data,
      options,
    });
  }

  function setSlider() {
    const targetContainer = $(".tracking-target"),
      inputTarget = $("#input-target", targetContainer),
      targetPercentageEl = $("#target-percentage", targetContainer),
      targetTooltipEl = $("#target-tooltip", wrapper);

    if (!targetContainer.length) return;

    let trackEl = $("#track", wrapper);

    const setChange = function () {
      trackEl = $("#track", wrapper);
      if (!trackEl.length) return;

      const eachPercentWidth = ($(inputTarget).width() - TARGET_LEFT_MARGIN - TARGET_RIGHT_MARGIN) / MAX;
      const val = parseInt(inputTarget.val(), 10);
      targetPercentageEl.text(`${val}%`);
      let pos = val * eachPercentWidth + TD_PADDING - (val / MAX) * 5;

      // position the title with the thumb
      const titlePos = pos - TD_PADDING - TARGET_LEFT_MARGIN - TARGET_RIGHT_MARGIN - TARGET_CIRCLE_PADDING;
      targetPercentageEl.css({ left: titlePos });

      // show "progress" on the track
      trackEl.css({ left: `${pos}px` });

      // set position of target tooltip
      const trackElX = trackEl[0].getBoundingClientRect().x;
      targetTooltipEl.css({ left: `${trackElX - DEFAULT_PADDING}px` });

      const grad = `linear-gradient(90deg,${COLORS.filled} ${val - 1}%, ${COLORS.disabled} ${val}%)`;
      inputTarget.css({ background: grad });
    };

    inputTarget.attr("max", MAX);
    inputTarget.on("change", setChange);
    setChange();
  }

  function setDimensions(targetInput) {
    // set height of tracker line as height of table body
    const tableEl = $(".table-wrapper tbody", wrapper),
      trackEl = $("#track", wrapper);
    trackEl.css({ height: tableEl.height() });

    // set width of target input same as zone TD
    const zoneTd = $(".score-zone", tableEl)[0];
    targetInput = $("#input-target", wrapper);
    if (zoneTd) targetInput.css({ width: $(zoneTd).width() + TARGET_LEFT_MARGIN + TARGET_RIGHT_MARGIN });
  }

  this.setSelects = () => {
    wrapper = $(".overall-tracking-wrapper");
    if (!wrapper || !wrapper.length) return;

    // Reset filters after reloading the page
    yearGroupInput.val(null).trigger("change.select2");

    yearGroupInput.select2({
      minimumResultsForSearch: Infinity,
    });

    $(document).ajaxComplete(() => {
      if (yearGroupInput.val()) {
        setDimensions();
        targetInput = $("#input-target", wrapper);
        targetInput.on("change", setTarget);
        setSlider();
      }
    });
  };

  this.initPage = () => {
    wrapper = $(".overall-tracking-wrapper");
    if (!wrapper || !wrapper.length) return;

    yearGroupInput = $("#overall_tracking_current_year_idx", wrapper);

    $(window).on("resize", setDimensions);
    $(window).on("resize", setSlider);
  };
})();
